import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import Loader from '../Loader/Loader';
import api from '../../api';
import './CreateProjectModal.css';
import WithRouter from '../Extensions/WithRouter';

class CreateProjectModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMCP: props.isOpenMCP,
      //errorMsg: '',
      projectError: '',
      versionError: '',
    };
    this.getByteLength = this.getByteLength.bind(this);
    this.closeCreateProjectModal = this.closeCreateProjectModal.bind(this);
    this.createProject = this.createProject.bind(this);
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    const { isOpenMCP } = this.props;
    if (prevProps.isOpenMCP !== isOpenMCP) {
      this.setState({
        isOpenMCP,
      }, () => {
        this.initValue();
      });
    }
  }

  getByteLength(text) {
    let l = 0;
    for (let i = 0; i < text.length; i++) l += (text.charCodeAt(i) > 128) ? 2 : 1;
    // return text.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, '$&$1$2').length;
    return l;
  }

  initValue() {
    this.setState({
      projectError: '',
      versionError: '',
    });
  }

  closeCreateProjectModal() {
    const { closeModal } = this.props;
    this.setState({
      isOpenMCP: false,
    });
    closeModal();
  }

  createProject() {
    const {
      state, isAlreadyExisted, createCallback, translate
    } = this.props;
    const name = this.projectName.value;
    const versions = [this.versionName.value];
    const owners = [state.user.email];
    this.initValue();
    if (isAlreadyExisted && isAlreadyExisted(name)) {
      this.setState({
        projectError: translate('modal.message.already_existed_project'),
      });
      return false;
    }
    const data = {
      name, versions, owners,
    };

    if (name.trim() === '') {
      this.setState({
        projectError: translate('modal.error.project_required'),
      });
      return false;
    }

    if (this.getByteLength(name) > 30) {
      this.setState({
        projectError: translate('modal.error.project_limited_char'),
      });
      return false;
    }

    if (versions[0].trim() === '') {
      this.setState({
        versionError: translate('modal.error.version_required'),
      });
      return false;
    }

    if (this.getByteLength(versions[0]) > 20) {
      this.setState({
        versionError: translate('modal.error.version_limited_char'),
      });
      return false;
    }

    api.createProject(data)
      .then((response) => {
        this.closeCreateProjectModal(true);
        if (createCallback) {
          createCallback(response.response);
        }
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;

        if (o.error === '422-356') {
          return this.setState({
            projectError: translate('modal.error.error_422_356'),
          });
        }

        if (o.error_description) {
          return this.setState({
            projectError: o.error_description,
          });
        }

        return this.setState({
          projectError: translate('modal.error.unknow_error'),
        });

      });
  }

  render() {
    const { projectError, versionError, isOpenMCP } = this.state;
    const { state, translate } = this.props;
    const projectErrorClass = projectError !== '' ? 'show' : '';
    const versionErrorClass = versionError !== '' ? 'show' : '';

    if (state.user.scanConfig.isLoading) {
      return <Loader />;
    }

    return (
      <Modal
        open={isOpenMCP}
        onClose={this.closeCreateProjectModal}
      >
        <form className="frmCreateProject">
          <div className="add_popup">
            <div className="add_popup_item">
              <h2 className="title">
                {translate('modal.title.new_project')}
              </h2>
              <div className="add_popup_item_content">
                <div className="label">{translate('modal.title.project_name')}</div>
                <div className={`value ${projectErrorClass}`}>
                  {/**autoFocus */}
                  <input ref={(ref) => { this.projectName = ref; }} type="text" placeholder={translate('modal.title.project_name')} />
                  <div className={`error ${projectErrorClass}`}>{projectError}</div>
                </div>
              </div>
              <div className="add_popup_item_content">
                <div className="label">{translate('modal.title.version')}</div>
                <div className={`value ${versionErrorClass}`}>
                  <input ref={(ref) => { this.versionName = ref; }} type="text" placeholder={translate('modal.title.version')} />
                  <div className={`error ${versionErrorClass}`}>{versionError}</div>
                </div>
              </div>
              <div className="add_popup_bottom">
                <a className="cancel" onClick={this.closeCreateProjectModal} onKeyUp={this.closeCreateProjectModal}>{translate('modal.button.cancel')}</a>
                <a className="save" onClick={this.createProject} onKeyUp={this.createProject}>{translate('modal.button.ok')}</a>
              </div>
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(CreateProjectModal)));
